import api from './'
import account from './accountEndpoints'
import finance from './financeEndpoints'
import travel from './travelEndpoints'
import general from './generalEndpoints'
import booking from './bookingEndpoints'
import payroll from './payrollEndpoints'

const endpoints = {
  ...account,
  ...finance,
  ...travel,
  ...general,
  ...booking,
  ...payroll,
}

export default endpoints